/*
 *
 * IBM Confidential
 *
 * OCO Source Materials
 *
 * (C) COPYRIGHT IBM CORP. 2024
 *
 * The source code for this program is not published or otherwise
 * divested of its trade secrets, irrespective of what has been
 * deposited with the U.S. Copyright Office.
 *
 */
import React from "react";
import PropTypes from "prop-types";
import { Button } from "carbon-components-react";
import { ArrowRight32 } from '@carbon/icons-react';
import { OAuthProfileService } from '../service/OAuthProfileService';

export default class CloudLogin extends React.PureComponent
{
    static propTypes = {
        isAdmin: PropTypes.bool,
        onError: PropTypes.func,
    };

    constructor( props )
    {
        super( props );
        this.state = {
            loading:  true,
            profiles: [],
        };
    }

    componentDidMount()
    {
        this._getProfiles();
    }

    async _getProfiles()
    {
        // OAuth profile login not supported for the admin console
        if( this.props.isAdmin ) return;

        this.setState( { loading: true } );
        try
        {
            const result = await OAuthProfileService.getProfileList();
            if( result && result.length > 0 )
            {
                this.setState(
                    {
                        loading: false,
                        profiles: result
                    }
                );
            }

            return result;
        }
        catch( err )
        {
            if( typeof this.props.onError === "function" )
            {
                this.props.onError( err );
            }
            this.setState( { errorMessage: err } );
            this.setState( { loading: false } );
        }
    }

    renderButtons()
    {
        let i = 0;

        return this.state.profiles.map( profile =>
        {
            const buttonProps = {
                className: "oauth_button",
                kind:      "tertiary",
                size:      "field",
                renderIcon: ArrowRight32,
                onClick:    () => this.handleOAuthLogin( profile )
            }

            return <Button {...buttonProps } key={ i++ }>
                <span className="oauth_button_text">
                    {
                        profile.loginImage
                            ? <img src={ profile.loginImage } alt="" width="24" height="24" style={ { marginRight: "8px" } } />
                            : ""
                    }
                    { profile.loginText ? profile.loginText : profile.name }
                </span>
            </Button>;
        } );
    }

    render()
    {
        if( !this.state.profiles || !this.state.profiles.length || this.state.profiles.length === 0 ) return "";

        const loginWrapperHeight = document.querySelector( "div.login-main-wrapper" )?.offsetHeight;

        return <div className='login-wrapper'>
            <hr className='horizontal-line' />
            <div className='oauth-wrapper'
                style={ { overflowY: "auto", marginTop: "1rem", maxHeight: `${ this.state.height - ( loginWrapperHeight + 110 ) }px` } }>
                { this.renderButtons() }
            </div>
        </div>
    }

    handleOAuthLogin( profile )
    {
        const pathname = window.location.pathname;
        let contextroot = pathname.substr( 0, pathname.length - 18 );  // 18 = /app/tririga-login

        const params = new URL( window.top.location ).searchParams;
        const redirectUrl = params.get( "redirectUrl" );
        if( redirectUrl && redirectUrl !== "" )
        {
            const decodedUrl = decodeURI( redirectUrl );
            const base64Url = btoa( decodedUrl );
            let url = contextroot + "/p/oauth/" + profile.name + "?appurl=" + base64Url;
            window.top.location = url;
            return;
        }

        let target = "/tririga";
        let isWebApp = false;
        let search;
        const loc = window.top.location;

        if( loc.pathname && loc.pathname.includes( "/p/web/" ) )
        {
            // Polymer UX App
            const path = loc.pathname;
            const i = path.lastIndexOf( "/" );
            if( i > 0 )
            {
                target = path.substring( i );
                isWebApp = true; // "p/web" indicates a webApp.
            }
            search = loc.search;
        }
        else if( loc.search )
        {
            let search = decodeURIComponent( loc.search );
            let i = search.lastIndexOf( "/" );
            if( i > 0 ) target = search.substring( i );
        }

        let url = contextroot + "/p/oauth/" + profile.name + target;
        if( search )
        {
            url += search;
            if( isWebApp ) url += "&webapp=true";
        }
        else
        {
            if( isWebApp ) url += "?webapp=true";
        }

        if( loc.hash && loc.hash !== "" )
        {
            let hash = loc.hash;
            if( hash.startsWith( "#" ) )
            {
                hash = hash.substring( 1 );
            }
            url += isWebApp ? "&" : "?";
            url += "hash=" + hash;
        }
        window.top.location = url;
    }
}